import ChatCenterRoutes from './chat-center'
import store from '@/store'
/* import cookie from '@/plugins/cookie'

function decodeJwt(token) {
  const base64Url = token.split('.')[1]
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
  return JSON.parse(atob(base64))
}
 */

export default [
  {
    name: "configurations",
    path: "configurations",
    meta: {
      isInMenu: true,
      title: 'main-menu.configuration.title',
      icon: 'fas fa-cog',
      type: 'title',
      order: 3,
      access_control : ['ROLE_ADMIN','ROLE_MANAGER'],
      ignoreChildren: true
    },
    props: true,
    component: () => import("@/views/configurations/TheIndex.vue"),
    children: [
      {
        name: 'selected-organization',
        path: ":name", 
        components: {
          configuration: () => import("@/views/configurations/pbx.vue"),
        },
        children: [
          {
            path: "users",
            name: "users",
            component: () => import("@/views/configurations/users/List.vue"),
          },
          {
            path: "users/new",
            name: "usersNew",
            component: () => import("@/views/configurations/users/Form.vue"),
          },
          {
            path: "users/:id/edit",
            name: "usersEdit",
            component: () => import("@/views/configurations/users/Form.vue"),
            props: true,
          },
          {
            path: "agents",
            name: "agents",
            component: () => import("@/views/configurations/agents/List.vue"),
          },
          {
            name: "agentsNew",
            path: "agents/new",
            component: () => import("@/views/configurations/agents/Form.vue"),
          },
          {
            name: "agentsEdit",
            path: "agents/:id/edit",
            component: () => import("@/views/configurations/agents/Form.vue"),
            props: true,
          },
          {
            path: "extensions",
            name: "extensions",
            component: () => import("@/views/extensions/List.vue"),
          },
          {
            name: "extensionsNew",
            path: "extensions/new",
            component: () => import("@/views/extensions/Form.vue"),
          },
          {
            name: "extensionsEdit",
            path: "extensions/:id/edit",
            component: () => import("@/views/extensions/Form.vue"),
            props: true,
          },
          {
            path: "chat-center",
            name: "chat-center",
            component: () => import("@/views/configurations/chat-center/TheIndex.vue"),
            children: ChatCenterRoutes
          },
          {
              name: "phoneWidgetsList",
              path: "/contact-me/phone-widgets",
              component: () => import('@/views/phone-widgets/List.vue'),
              props: true
            },
            {
              name: "phoneWidgetsNew",
              path: "/contact-me/phone-widgets/new",
              component: () => import('@/views/phone-widgets/Form.vue'),
              props: true
            },
            {
              name: "phoneWidgetsEdit",
              path: "/contact-me/phone-widgets/:id/edit",
              component: () => import('@/views/phone-widgets/Form.vue'),
              props: true
            }
        ],
        props: true,
      }
    ],
    beforeEnter : (to, from, next) => {
        if (to.name === 'configurations') {
          store.commit('contactMe/SET_ORGANIZATION_ID', null)
        }
        next()
    }
  },
  {
    path: "my-organizations",
    name: "organizations",
    component: () => import("@/views/organizations/List.vue"),
  },
]
